module.exports = __webpack_public_path__ + "ptc_nakagawa_D2.9d0b650f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_D2.jpg
// module id = z+FP
// module chunks = 0